import React, { useEffect, useCallback, useState } from 'react';
import { Container, Button, Row, Col, Card, Modal, Spinner } from 'react-bootstrap';
import FundsRequestService from 'services/funds-request';

import "./style.scss";
import { ArrowBackIos, WidgetsOutlined, RemoveCircleOutline, ArrowUpward, ArrowDownward, ExpandMore, ExpandLess, CalendarToday } from '@material-ui/icons';
import { useHistory } from 'react-router';
import { formatBRL } from 'helpers/format';
import DatePicker from 'react-datepicker';
import { useCompany, useUser } from 'models';
import { formatDate, subtractDays } from 'helpers/date';
import Unauthorized from 'components/Unauthorized';
import { getTitleByDay, getTitleByMonth } from './utils';
import {
  useParams
} from "react-router-dom";

function Summary({companyId, blockTransferred, fiscalYear}){
  const [ data, setData ] = useState({
    "Aberta":0,
    "Autorizada":0,
    "Ação Rejeitada":0,
    "Cancelada":0,
    "Em Processo Pagamento":0,
    "Finalizada":0,
    "NFs Aprovadas":0,
    "NFs Aprovação":0,
    "NFs Rejeitadas":0,
    "total":0,
    "actions_in_process":0,
    "transferred":0,
  });

  const [opened, setOpened] = useState(false);
  const [showActions, setShowActions] = useState(false);

  useEffect(() => {
    FundsRequestService.getDetailSummary(fiscalYear,companyId,3).then(({data})=>{
      data.actions_in_process = (
        data["Aberta"] + 
        data["Autorizada"] +
        data["Ação Rejeitada"] +
        data["Em Processo Pagamento"] +
        data["NFs Aprovadas"] +
        data["NFs Aprovação"] +
        data["NFs Rejeitadas"]
      );
      setData(data)
    })
  },[companyId, fiscalYear]);

  return (
    <div className="area-summary">
      <table>
        {opened?(
          <>
            <tbody>
              <tr>
                <td></td>
                <td colSpan="2">Fundo Scancash</td>
                <td>{formatBRL(data.total - data["transferred"])}</td>
              </tr>
              {/* {blockTransferred?<></>:<tr>
                <td></td>
                <td colSpan="2">Transferência Inovação</td>
                <td>{formatBRL(data["transferred"])}</td>
              </tr>} */}
              <tr>
                <td className="btn-expand-more">
                  {showActions?
                  <ExpandLess onClick={()=>setShowActions(!showActions)}/>:
                  <ExpandMore onClick={()=>setShowActions(!showActions)}/>}
                </td>
                <td colSpan="2">Em Processo</td>
                <td>{formatBRL(data.actions_in_process)}</td>
              </tr>
              {showActions?(
                <>
                  {Object.keys(data).map(d=>{
                    return {name:d, value:data[d]}
                  }).filter(d=>{
                    if(d.name === "actions_in_process") return false;
                    if(d.name === "total") return false;
                    if(d.name === "Cancelada") return false;
                    if(d.name === "Finalizada") return false;
                    if(d.name === "transferred") return false;
                    return true;
                  }).map((d,k)=>{
                    return (
                      <tr key={k} className="area-actions-status">
                        <td></td>
                        <td colSpan="2">{d.name}</td>
                        <td>{formatBRL(d.value)}</td>
                      </tr>
                    );
                  })}
                </>
              ):(<></>)}
              <tr>
                <td></td>
                <td colSpan="2">Concluido</td>
                <td>{formatBRL(data["Finalizada"])}</td>
              </tr>
              <tr>
                <td></td>
                <td colSpan="2">Cancelado</td>
                <td>{formatBRL(data["Cancelada"])}</td>
              </tr>
            </tbody>
          </>
        ):(<></>)}
        <tfoot>
          <tr>
            <td>
              {opened?
              <ExpandLess onClick={()=>setOpened(!opened)}/>:
              <ExpandMore onClick={()=>setOpened(!opened)}/>}
            </td>
            <td colSpan="2">Verba Disponível:</td>
            <td className="pr-3">{formatBRL((data.total) - (data["Autorizada"] + data.actions_in_process + data["Finalizada"]))}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

function RenderPeriod({onFilter, filters, user}){
  const [showModal, setShowModal] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [defaultPeriod, setDefaultPeriod] = useState(null);

  const [periods] = useState([
    {title: "Últimos 15 dias",sd:formatDate(subtractDays(15,new Date(user.current_date))), ed:formatDate(new Date(user.current_date))},
    {title: "Últimos 30 dias",sd:formatDate(subtractDays(30,new Date(user.current_date))), ed:formatDate(new Date(user.current_date))},
    {title: "Últimos 60 dias",sd:formatDate(subtractDays(60,new Date(user.current_date))), ed:formatDate(new Date(user.current_date))},
    {title: "Últimos 90 dias",sd:formatDate(subtractDays(90,new Date(user.current_date))), ed:formatDate(new Date(user.current_date))},
  ])

  const filter = useCallback(()=>{
    if(onFilter){
      if(!defaultPeriod){
        let sd = formatDate(startDate);
        let ed = formatDate(endDate);
        onFilter(sd,ed);
      } else {
        onFilter(periods[defaultPeriod-1].sd,periods[defaultPeriod-1].ed,defaultPeriod);
      }
    }
  },[startDate, endDate, defaultPeriod, periods, onFilter]);

  const canFilter = (!!startDate && !!endDate) || !!defaultPeriod;
  const hasFilter = ()=>{
    try {
      return !!filters["start_date"] && !!filters["end_date"]
    } catch (error) {
      return false;
    }
  };
  const hasFilterDateDefault = ()=>{
    try {
      return hasFilter() && !!filters["default_date"];
    } catch (error) {
      return false;
    }
  };
  function formatDateTitle(date){
    let [y,m,d] = date.split("-");
    return `${d}/${m}/${y}`;  
  }

  const title = hasFilterDateDefault()?periods[filters["default_date"]-1].title:(hasFilter()?`${formatDateTitle(filters["start_date"])} - ${formatDateTitle(filters["end_date"])}`:"Período");

  return (
    <>
      <div className={"filter-tag filter-period-tag"+(hasFilter()?" filter-tag-selected":"")} onClick={()=>setShowModal(true)}>
        <CalendarToday/>{title}
      </div>
      {showModal?(
        <Modal show={true} 
        onHide={()=>{
          setShowModal(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        className="modal-filters modal-statement-detail-filter"
        centered>
          <Modal.Header closeButton>
            <Modal.Title>Filtrar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12">
                <div className="filter-periods-default-list">
                  {periods.map((p,k)=>{
                    return (
                      <div key={k} className={"filter-period-item filter-tag"+(defaultPeriod && defaultPeriod-1 === k?" filter-period-item-selected":"")} onClick={()=>{
                        setDefaultPeriod(k+1);
                      }}>
                        {p.title}
                      </div>
                    )
                  })}
                </div>
              </Col>
              <Col xs="12">
                <label className="mb-0 mt-2">Período específico</label>
              </Col>
              <Col>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  locale="pt-BR"
                  placeholderText="De"
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date)
                    setDefaultPeriod(null)
                  }}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  maxDate={endDate || new Date(user.current_date)}
                  className="form-control form-control-sm"
                />
              </Col>
              <Col>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  locale="pt-BR"
                  placeholderText="Até"
                  selected={endDate}
                  onChange={(date) => {
                    setEndDate(date)
                    setDefaultPeriod(null)
                  }}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  maxDate={new Date(user.current_date)}
                  className="form-control form-control-sm"
                />
              </Col>
            </Row>
            <Row className="mt-1 justify-content-center">
              <Col xs="auto">
                <Button size="sm" onClick={()=>{
                  setShowModal(false);
                  if(hasFilter){
                    setStartDate(null)
                    setEndDate(null)
                    setDefaultPeriod(null)
                    if(onFilter)onFilter(null,null);
                  } else {
                    setDefaultPeriod(null)
                    setStartDate(null)
                    setEndDate(null)
                  }
                }}>{hasFilter()||hasFilterDateDefault()?"Limpar":"Cancelar"}</Button>
              </Col>
              <Col xs="auto">
                <Button size="sm" disabled={!canFilter} onClick={()=>{
                  if(canFilter){
                    setShowModal(false);
                    filter();
                  }}}>Filtrar</Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      ):<></>}
    </>
  );
}

function Detail({companyId, fiscalYear, user}){
  const [ data, setData ] = useState({});
  const [offset, setOffset] = useState(null);
  const [filters, setFilters] = useState({});
  const [load, setLoad] = useState(true);
  const [isLoadMore, setIsLoadMore] = useState(false);

  const formatData = useCallback((data, reset = false)=>{
    
    setData((old)=>{
      let months = !reset?{...old}:{};
      for (let i = 0; i < data.length; i++) {
        const element = {...data[i]};
        const v = element.date.split(',');

        if(!months[getTitleByMonth(v)]) {// add Month
          months[getTitleByMonth(v)] = {}
          months[getTitleByMonth(v)][getTitleByDay(v)] = {list:[element], value_of_day: element.total_value}
        } else if(!months[getTitleByMonth(v)][getTitleByDay(v)]){ // add Day
          months[getTitleByMonth(v)][getTitleByDay(v)] = {list:[element], value_of_day: element.total_value}
        } else { // add Element
          months[getTitleByMonth(v)][getTitleByDay(v)].list.push(element)
        }
      }
      return months;
    });
  },[]);

  const loadMore = useCallback(()=>{
    if(offset){
      setIsLoadMore(true);
      FundsRequestService.getDetail(fiscalYear,companyId,3,{offset:offset, ...filters}).then(({data})=>{
        formatData(data.list);
        setOffset(data.offset);
        setIsLoadMore(false);
      })
    }
  },[offset, filters, companyId, formatData, fiscalYear]);

  useEffect(()=>{
    setLoad(true);
    FundsRequestService.getDetail(fiscalYear,companyId,3, filters).then(({data})=>{
      formatData(data.list,true);
      setOffset(data.offset);
      setLoad(false);
    })
  },[formatData, filters, companyId, fiscalYear]);

  function renderValueWithIcon(item){
    if(item.status && item.status === 10){
      return <label className="ignore">{formatBRL(item.value)}<RemoveCircleOutline/></label>
    }
    if(item.value>0){
      return <label className="positive">{formatBRL(item.value)}<ArrowUpward/></label>
    }
    if(item.value<0){
      return <label className="negative">{formatBRL(item.value)}<ArrowDownward/></label>
    }
    return <label className="ignore">{formatBRL(item.value)}<RemoveCircleOutline/></label>
  }

  return (
    <div className="area-statement-detail">
      <div className="area-statement-detail-filter">
        <RenderPeriod onFilter={(sd,ed, default_date)=>{
            setFilters(old=>{
              return {...old, start_date: sd, end_date: ed, default_date};
            })
          }}
          filters={filters}
          user={user}
        />
      </div>
      {load?(
        <div style={{textAlign: "center"}}>
          <Spinner animation="border" />
        </div>
      ):(<>
        {Object.keys(data).map((m, key_m)=>{
          // let group = {date: g, ...data[g]};
          let month = data[m];
          return (
            <div key={key_m} className="mt-3">
              <h5>{m}</h5>
              {Object.keys(month).map((d,key_d)=>{
                let day = {date: d, ...month[d]};
                return (
                  <div key={key_d} className="area-statement-group">
                    <Row className="area-statement-groupbar justify-content-between">
                      <Col xs="auto"><label className="title-day">{day.date}</label></Col>
                      <Col xs="auto"><span>Saldo do dia</span><label>{formatBRL(day.value_of_day)}</label></Col>
                    </Row>
                    <div className="area-statement-values">
                      {day.list.map((item,key_i)=>{
                        return (
                          <div key={key_i}>
                            <Row className="area-statement-itembar justify-content-between align-items-center">
                              <Col xs="auto">
                                <label>
                                  {
                                  item.action_id?
                                  <>Usando na ação <a href={`/elite/${item.action_type===4?"innovation":"scancash"}/show/${item.action_id}`} target="_blank">#{item.action_id}</a> - {item.status_name}</>
                                  :item.observation
                                  }
                                </label>
                                {item.action_id?<div className="label-small">{(()=>{
                                  let type = null;
                                  switch (item.action_type) {
                                    case 3:
                                      type = "ScanCash"
                                      break;
                                    case 2:
                                      type = "Resgate"
                                      break;
                                    case 4:
                                      type = "Inovação"
                                      break;
                                    default:
                                      break;
                                  }
                                  return `${item.action_name} (${type})`
                                })()}</div>:<></>}
                              </Col>
                              <Col xs="auto">
                                <label>{renderValueWithIcon(item)}</label>
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          )
        })}
        {Object.keys(data).length===0?(
          <div style={{textAlign: "center"}}>Sem dados na lista</div>
        ):<></>}
        {offset?(
        <Row className="mt-4">
          <Col>
            {isLoadMore?<div style={{textAlign: "center"}}><Spinner animation="border" /></div>:<Button onClick={loadMore} className="w-100">Carregar mais</Button>}
          </Col>
        </Row>):
        <></>}
      </>)}
    </div>
  );
}

export default function(){
  const { fiscal_year } = useParams();
  const user = useUser();
  const history = useHistory();   
  const {company} = useCompany();

  //const fiscalYear = !!fiscal_year?user.fiscal_years.filter(a=>a.fiscal_year===fiscal_year)[0].id:user.fiscal_year.id
  const {id: fiscalYear} = JSON.parse(localStorage.getItem("Elite:fiscalYear")) ?? { id: 12 }
  if(!company){
    return <Unauthorized/>
  }

  return (
    <Container>
      <Row className="mt-2">
        <Button variant="link" className="link-back" onClick={() => history.goBack()}>
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Button>
      </Row>
      <Row className="mt-1 d-flex align-items-end">
        <Col className="d-flex">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Extrato ScanCash{!!fiscal_year?` - ${fiscal_year}`:""}</h5>
        </Col>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 col-12">
          <Summary companyId={company.id} blockTransferred={company.isScancash()} fiscalYear={fiscalYear}/>
          <Detail companyId={company.id} fiscalYear={fiscalYear} user={user}/>
        </Card.Body>
      </Row>
    </Container>
    );
};
